// this is exposed for testing purposes
// eslint-disable-next-line no-console
export const report = (message) => console.warn(message);
